var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_682)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.3571C0 6.42791 6.42791 0 14.3571 0C22.2864 0 28.7143 6.42791 28.7143 14.3571C28.7143 22.2864 22.2864 28.7143 14.3571 28.7143C6.42791 28.7143 0 22.2864 0 14.3571Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_245_682",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.536 7.17847H8.07617V20.6383H21.536V7.17847Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_245_682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.591 9.42152H17.2735C17.4284 9.42152 17.5539 9.29596 17.5539 9.1411V7.45862C17.5539 7.30378 17.4284 7.17822 17.2735 7.17822H15.591C13.8882 7.18009 12.5083 8.55998 12.5065 10.2628V12.2257H10.5436C10.3887 12.2257 10.2632 12.3512 10.2632 12.5061V14.1886C10.2632 14.3434 10.3887 14.469 10.5436 14.469H12.5065V20.3576C12.5065 20.5125 12.632 20.6381 12.7869 20.6381H14.4694C14.6243 20.6381 14.7498 20.5125 14.7498 20.3576V14.469H16.7127C16.8333 14.4689 16.9404 14.3916 16.9785 14.2772L17.5394 12.5947C17.5883 12.4478 17.5089 12.289 17.3619 12.24C17.3334 12.2305 17.3036 12.2257 17.2735 12.2257H14.7498V10.2628C14.7498 9.79816 15.1264 9.42152 15.591 9.42152Z",
    fill: "#1E2132"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.384dc9fc2010841a05a4dfd447329668.svg";
export { ForwardRef as ReactComponent };